/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { EArgosReportsState } from "../../../../../constants/colors"
import VAR_COMMON_CONSTANTS from "../../../../../constants/globalVariables"


export const enum AdasProgramsReportPages {
  SENSING_SYSTEM_REQUIREMENT = 'sensingSystemRequirement',
  SENSOR_COMPONENT_REQUIREMENT = 'sensorComponentRequirement',
  WORLD_MODEL_SOLUTION_REQUIREMENT = 'worldModelSolutionRequirement',
}

export const enum AdasProgramsReportPageIdx {
  SENSING_SYSTEM_REQUIREMENT = '1',
  SENSOR_COMPONENT_REQUIREMENT = '2',
  WORLD_MODEL_SOLUTION_REQUIREMENT = '3',
}

export const pageToHtabIndexMap: Record<string, AdasProgramsReportPageIdx> = {
  [AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT]: AdasProgramsReportPageIdx.SENSING_SYSTEM_REQUIREMENT,
  [AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT]: AdasProgramsReportPageIdx.SENSOR_COMPONENT_REQUIREMENT,
  [AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT]: AdasProgramsReportPageIdx.WORLD_MODEL_SOLUTION_REQUIREMENT,
}

export const htabIndexToPageMap: Record<string, AdasProgramsReportPages> = {
  [AdasProgramsReportPageIdx.SENSING_SYSTEM_REQUIREMENT]: AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT,
  [AdasProgramsReportPageIdx.SENSOR_COMPONENT_REQUIREMENT]: AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT,
  [AdasProgramsReportPageIdx.WORLD_MODEL_SOLUTION_REQUIREMENT]: AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT,
}

export const enum VehicleProgramsReportPages {
  SENSING_SYSTEM_PERFORMANCE = 'sensingSystemPerformance',
}

export const enum ReportPages {
  SENSING_SYSTEM_REQUIREMENT = AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT,
  SENSOR_COMPONENT_REQUIREMENT = AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT,
  WORLD_MODEL_SOLUTION_REQUIREMENT = AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT,
  SENSING_SYSTEM_PERFORMANCE = VehicleProgramsReportPages.SENSING_SYSTEM_PERFORMANCE,
}

export const enum EUpdateReportsStatus {
  NOT_STARTED = 'notStarted',
  IN_PROGRESS = 'inProgress',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export type BaseReportsTableData = {
  reportId: string
  reportName: string
  dataSetState: EArgosReportsState
  requirement: string
  reportFormat: string
  comments: string
}

export type RedLineReportsTableData = {
  coverageAnalysisStudyId: string
  redLineDataSetId: string
  redLineDataSetName: string
  redLineDataSetMergeConfiguration: string
}

export type GreenLineReportsTableData = {
  sensingArchitectureStudyId: string
  greenLineDataSetId: string
  greenLineDataSetName: string
  sensorId: string
  sensorName: string
  sensorLocation: string
  sensorModality: string
  sensorNameModality?: string
}

export type ReportsTableData = BaseReportsTableData & (RedLineReportsTableData | GreenLineReportsTableData)
